export default __webpack_public_path__ + "gorilla-logo.ef0b66e5.png";